export const TOGGLE_LOADING = 'accidents/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'accidents/TOGGLE_SUCCESS'
export const TOGGLE_LOADING_SEND = 'accidents/TOGGLE_LOADING_SEND'
export const TOGGLE_SUCCESS_SEND = 'accidents/TOGGLE_SUCCESS_SEND'
export const TOGGLE_ERROR = 'accidents/TOGGLE_ERROR'
export const SET_ACCIDENTS = 'accidents/SET_ACCIDENTS'
export const SET_REPORT_XML = 'accidents/SET_REPORT_XML'
export const SET_ACCIDENT = 'accidents/SET_ACCIDENT'
export const RESET_REPORT_XML = 'accidents/RESET_REPORT_XML'

export const GET_PERSON = 'accidents/GET_PERSON'
export const GET_PERSON_DONE = 'accidents/GET_PERSON_DONE'
export const GET_PERSON_FAIL = 'accidents/GET_PERSON_FAIL'

export const SEND_SEVERITY = 'accidents/SEND_SEVERITY'
export const SEND_SEVERITY_DONE = 'accidents/SEND_SEVERITY_DONE'
export const SEND_SEVERITY_FAIL = 'accidents/SEND_SEVERITY_FAIL'

export const SEND_SEVERITY_XML = 'accidents/SEND_SEVERITY_XML'
export const SEND_SEVERITY_XML_DONE = 'accidents/SEND_SEVERITY_DONE_XML'
export const SEND_SEVERITY_XML_FAIL = 'accidents/SEND_SEVERITY_FAIL_XML'

export const SEND_INVESTIGATION = 'accidents/SEND_INVESTIGATION'
export const SEND_INVESTIGATION_DONE = 'accidents/SEND_INVESTIGATION_DONE'
export const SEND_INVESTIGATION_FAIL = 'accidents/SEND_INVESTIGATION_FAIL'

export const SEND_INVESTIGATION_XML = 'accidents/SEND_INVESTIGATION_XML'
export const SEND_INVESTIGATION_XML_DONE = 'accidents/SEND_INVESTIGATION_XML_DONE'
export const SEND_INVESTIGATION_XML_FAIL = 'accidents/SEND_INVESTIGATION_XML_FAIL'

export const SEND_COMISSION = 'accidents/SEND_COMISSION'
export const SEND_COMISSION_DONE = 'accidents/SEND_COMISSION_DONE'
export const SEND_COMISSION_FAIL = 'accidents/SEND_COMISSION_FAIL'

export const SEND_COMISSION_XML = 'accidents/SEND_COMISSION_XML'
export const SEND_COMISSION_XML_DONE = 'accidents/SEND_COMISSION_XML_DONE'
export const SEND_COMISSION_XML_FAIL = 'accidents/SEND_COMISSION_XML_FAIL'

export const GET_FILLING_ACT = 'accidents/GET_FILLING_ACT'
export const GET_FILLING_ACT_DONE = 'accidents/GET_FILLING_ACT_DONE'
export const GET_FILLING_ACT_FAIL = 'accidents/GET_FILLING_ACT_FAIL'

export const SEND_FILLING_ACT = 'accidents/SEND_FILLING_ACT'
export const SEND_FILLING_ACT_DONE = 'accidents/SEND_FILLING_ACT_DONE'
export const SEND_FILLING_ACT_FAIL = 'accidents/SEND_FILLING_ACT_FAIL'

export const SEND_FILLING_ACT_XML = 'accidents/SEND_FILLING_ACT_XML'
export const SEND_FILLING_ACT_XML_DONE = 'accidents/SEND_FILLING_ACT_DONE_XML'
export const SEND_FILLING_ACT_XML_FAIL = 'accidents/SEND_FILLING_ACT_FAIL_XML'

export const GET_INVESTIGATION_REPORT = 'accidents/GET_INVESTIGATION_REPORT'
export const GET_INVESTIGATION_REPORT_DONE = 'accidents/GET_INVESTIGATION_REPORT_DONE'
export const GET_INVESTIGATION_REPORT_FAIL = 'accidents/GET_INVESTIGATION_REPORT_FAIL'

export const GET_ACT_REPRESENTATIVE = 'accidents/GET_ACT_REPRESENTATIVE'
export const GET_ACT_REPRESENTATIVE_DONE = 'accidents/GET_ACT_REPRESENTATIVE_DONE'
export const GET_ACT_REPRESENTATIVE_FAIL = 'accidents/GET_ACT_REPRESENTATIVE_FAIL'

export const SEND_ACT_REPRESENTATIVE_XML = 'accidents/SEND_ACT_REPRESENTATIVE_XML'
export const SEND_ACT_REPRESENTATIVE_XML_DONE = 'accidents/SEND_ACT_REPRESENTATIVE_XML_DONE'
export const SEND_ACT_REPRESENTATIVE_XML_FAIL = 'accidents/SEND_ACT_REPRESENTATIVE_XML_FAIL'

export const SEND_ACT_REPRESENTATIVE = 'accidents/SEND_ACT_REPRESENTATIVE'
export const SEND_ACT_REPRESENTATIVE_DONE = 'accidents/SEND_ACT_REPRESENTATIVE_DONE'
export const SEND_ACT_REPRESENTATIVE_FAIL = 'accidents/SEND_ACT_REPRESENTATIVE_FAIL'

export const RECALL_FILLING_ACT = 'accidents/RECALL_FILLING_ACT'
export const RECALL_FILLING_ACT_DONE = 'accidents/RECALL_FILLING_ACT_DONE'
export const RECALL_FILLING_ACT_FAIL = 'accidents/RECALL_FILLING_ACT_FAIL'
